// contact.js
import './bootstrap';

import { createApp } from 'vue';

import ContactFormLoader from './components/ContactFormLoader.vue'
import ConsentBanner from './components/ConsentBanner.vue';
import { loadPrimeVue } from '@/utils/loadPrimeVue.js'

const app = createApp({});

// Provide the loader via a global property or a prop wrapper
app.provide('ContactFormLoader', () => import('./components/ContactForm.vue'))

app.component('contact-form-loader', ContactFormLoader);
app.component('consent-banner', ConsentBanner);

await loadPrimeVue(app)

app.mount('#app');
